<footer class="w-full bg-[#2a3a6c] text-white py-4 flex flex-col items-center justify-center">
  <div class="text-center text-sm w-full px-2">
    Copyright © {{ year }} by {{ companyName }}
  </div>
</footer>
